/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Achievementsblade_Gold1Inputs */

const id_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emas`)
};

const ms_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emas`)
};

const da_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guld`)
};

const de_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

const en_us2_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

const es_es2_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oro`)
};

const es_mx2_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oro`)
};

const fil_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

const fr_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or`)
};

const it_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oro`)
};

const hu_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arany`)
};

const nl_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goud`)
};

const no_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gull`)
};

const pl_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Złoto`)
};

const pt_br2_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

const pt_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouro`)
};

const ro_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aur`)
};

const fi_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulta`)
};

const sv_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guld`)
};

const vi_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vàng`)
};

const tr_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altın`)
};

const cs_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zlato`)
};

const bg_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Злато`)
};

const ru_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Золото`)
};

const uk_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Золото`)
};

const ar_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذهب`)
};

const hi_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वर्ण`)
};

const th_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทอง`)
};

const ja_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴールド`)
};

const zh_cn2_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

const zh_hant1_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

const ko_components_achievementsblade_gold1 = /** @type {(inputs: Components_Achievementsblade_Gold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold`)
};

/**
* | output |
* | --- |
* | "Gold" |
*
* @param {Components_Achievementsblade_Gold1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_achievementsblade_gold1 = /** @type {((inputs?: Components_Achievementsblade_Gold1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Achievementsblade_Gold1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_achievementsblade_gold1(inputs)
	if (locale === "ms") return ms_components_achievementsblade_gold1(inputs)
	if (locale === "da") return da_components_achievementsblade_gold1(inputs)
	if (locale === "de") return de_components_achievementsblade_gold1(inputs)
	if (locale === "en-US") return en_us2_components_achievementsblade_gold1(inputs)
	if (locale === "es-ES") return es_es2_components_achievementsblade_gold1(inputs)
	if (locale === "es-MX") return es_mx2_components_achievementsblade_gold1(inputs)
	if (locale === "fil") return fil_components_achievementsblade_gold1(inputs)
	if (locale === "fr") return fr_components_achievementsblade_gold1(inputs)
	if (locale === "it") return it_components_achievementsblade_gold1(inputs)
	if (locale === "hu") return hu_components_achievementsblade_gold1(inputs)
	if (locale === "nl") return nl_components_achievementsblade_gold1(inputs)
	if (locale === "no") return no_components_achievementsblade_gold1(inputs)
	if (locale === "pl") return pl_components_achievementsblade_gold1(inputs)
	if (locale === "pt-BR") return pt_br2_components_achievementsblade_gold1(inputs)
	if (locale === "pt") return pt_components_achievementsblade_gold1(inputs)
	if (locale === "ro") return ro_components_achievementsblade_gold1(inputs)
	if (locale === "fi") return fi_components_achievementsblade_gold1(inputs)
	if (locale === "sv") return sv_components_achievementsblade_gold1(inputs)
	if (locale === "vi") return vi_components_achievementsblade_gold1(inputs)
	if (locale === "tr") return tr_components_achievementsblade_gold1(inputs)
	if (locale === "cs") return cs_components_achievementsblade_gold1(inputs)
	if (locale === "bg") return bg_components_achievementsblade_gold1(inputs)
	if (locale === "ru") return ru_components_achievementsblade_gold1(inputs)
	if (locale === "uk") return uk_components_achievementsblade_gold1(inputs)
	if (locale === "ar") return ar_components_achievementsblade_gold1(inputs)
	if (locale === "hi") return hi_components_achievementsblade_gold1(inputs)
	if (locale === "th") return th_components_achievementsblade_gold1(inputs)
	if (locale === "ja") return ja_components_achievementsblade_gold1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_achievementsblade_gold1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_achievementsblade_gold1(inputs)
	return ko_components_achievementsblade_gold1(inputs)
});
export { components_achievementsblade_gold1 as "components.achievementsBlade.gold" }